__turbopack_context__.v({
  "textFlex": "UploadedFile-module__wXwP3q__textFlex",
});
